import React, { useState } from 'react';
import './SubscriptionExpiredModal.scss';
import { FaCrown, FaExclamationTriangle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../context/AuthContext.js";
import PlanSelectionModal from '../PlanSelectionModal/PlanSelectionModal';


const SubscriptionExpiredModal = ({ isOpen, companyId, onUpgrade }) => {
  const navigate = useNavigate();
  const { logout} = useAuth();
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  
  if (!isOpen) return null;
  
  const handleUpgrade = () => {
    if (companyId) {
      setIsPlanModalOpen(true);
    } else {
      console.error("Company ID not found");
    }
  };

  const handleLogout = () => {
    logout();
    // Delay navigation to allow state updates to complete
    setTimeout(() => {
      navigate("/");
    }, 0);
  };

  const handleSelectPlan = (selectedPlan, companyId) => {
    console.log('Selected Plan:', selectedPlan);
    console.log('Company ID:', companyId);
    // TODO: Implement payment flow with planId and companyId
    // For now, just log the data
    // alert(`Plan Selected: ${selectedPlan.name}\nPlan ID: ${selectedPlan._id}\nCompany ID: ${companyId}\nPrice: ₹${selectedPlan.price}`);
  };

  return (
    <>
      <div className="subscription-expired-modal-overlay">
        <div className="subscription-expired-modal">
          <div className="modal-header">
            <div className="warning-icon">
              <FaExclamationTriangle size={32} color="#ff6b35" />
            </div>
            <h2>Subscription Expired</h2>
          </div>
          
          <div className="modal-body">
            <div className="expired-message">
              <p>Your subscription period has ended. To continue using all features of LawsuitPro, please renew your plan.</p>
            </div>
          </div>
          
          <div className="modal-footer">
            <button 
              className="upgrade-button-primary"
              onClick={handleUpgrade}
            >
              <FaCrown size={16} />
              Upgrade Your Plan
            </button>
            <button className="logout-button-secondary" onClick={handleLogout}>
              Logout
            </button>
            {/* <p className="upgrade-note">
              Secure payment processing • Instant activation
            </p> */}
          </div>
        </div>
      </div>

      <PlanSelectionModal
        isOpen={isPlanModalOpen}
        companyId={companyId}
        onClose={() => setIsPlanModalOpen(false)}
        onSelectPlan={handleSelectPlan}
      />
    </>
  );
};

export default SubscriptionExpiredModal;